/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { CKEditor5, CKEditor5PremiumFeatures } from '@ckeditor/ckeditor5-metadata';

import { plugins } from '../../constants/plugins';
import type { EditorPlugins } from '../../types/EditorPlugins';
import type { ViewPlugin } from '../../types/ViewPlugin';

// In run-time, these packages are injected via CDN (`script[type=importmap]`).
import * as ckeditor5 from 'ckeditor5';
import * as ckeditor5PremiumFeatures from 'ckeditor5-premium-features';

export function getPluginConstructorsByNames( editorPlugins: EditorPlugins ): Array<CKEditor5.PluginConstructor> {
	return editorPlugins
		.map( pluginName => plugins.find( item => item.className === pluginName )! )
		.filter( ( plugin ): plugin is ViewPlugin => !!plugin && !plugin.disallowInPreview )
		.map( plugin => {
			if ( plugin.installPackage === 'ckeditor5-premium-features' ) {
				return ckeditor5PremiumFeatures[ plugin.className as keyof typeof CKEditor5PremiumFeatures ] as CKEditor5.PluginConstructor;
			}

			return ckeditor5[ plugin.className as keyof typeof CKEditor5 ] as CKEditor5.PluginConstructor;
		} );
}
